
import "./panel.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useState, useEffect, useTransition } from "react";

/* banco de dados */
import { db, apimaker } from "../../services/firebaseConnection";
import { collection, getDocs, getDoc, doc, where, query, limit, orderBy } from "firebase/firestore";

/* navegação */
import { useNavigate } from "react-router-dom";

/* redux */
import { useSelector } from "react-redux";

/* funções auxiliares */
import { statusAgentsPanel, formatTimestamp, dateDiffDias } from "../../services/functions/functions.ts";

/* gráficos */
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from "recharts";

/* imagens */
import panel_agent from "../../assets/panel_agent.png";
import panel_graphics from "../../assets/panel_graphics.png";
import panel_payment from "../../assets/panel_payment.png";
import panel_config from "../../assets/panel_config.png";
import panel_schedule from "../../assets/panel_schedule.png";


/*
status dos agentes e ações:
  0	- cliente foi cadastrado - criar agente
  1	- agente foi criado mas não foi configurado - configurar agente
  2	- agente configurado mas pendente de ativação - ver detalhes
  3	- agente ativado - período de testes (7 dias)
  4	- agente ativado - cliente assinante
  5	- agente desativado (pedido do cliente) - criar agente
  6	- agente desativado - falta de pagamento - criar agente
  7	- agente desativado - uso interno - criar agente
*/


export default function Panel() {

    const [dadosAgent, setDadosAgent] = useState({id: "0", nome: "", dt_criacao: "", numero: "", status: 0, dt_configuracao: "", dt_ativacao: "", dt_desativacao: ""});
    const [dadosBilling, setDadosBilling] = useState([]);
    const [difhrs, setDifhrs] = useState(0);

    const { user } = useSelector((rootReducer) => rootReducer.user);
    const { agent } = useSelector((rootReducer) => rootReducer.agent);

    const [chart, setChart] = useState([]);
    const [agenda, setAgenda] = useState([]);

    const [client, setClient] = useState([]);

    const navigate = useNavigate();

    const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const [isPending1, startTransition1] = useTransition();
    const [isPending2, startTransition2] = useTransition();
    const [isPending3, startTransition3] = useTransition();
    const [isPending4, startTransition4] = useTransition();
    const [isPending5, startTransition5] = useTransition();

    const [loaded1, setLoaded1] = useState(false);
    const [loaded2, setLoaded2] = useState(false);
    const [loaded3, setLoaded3] = useState(false);
    const [loaded4, setLoaded4] = useState(false);
    const [loaded5, setLoaded5] = useState(false);

    const panel = statusAgentsPanel(agent.status);

    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {

        startTransition1(async () => {
            await wait(500);
            await load_agente();
            setLoaded1(true);
        });

        if(agent.status === 3 || agent.status === 4) {
            startTransition2(async () => {
                await wait(1000);
                await create_chart();
                setLoaded2(true);
            });
        }

        if(agent.status === 4) {
            startTransition4(async () => {
                await wait(500);
                await load_payments();
                setLoaded4(true);
            });
        }

        startTransition3(async () => {
            await wait(500);
            await load_client();
            setLoaded3(true);
        });

        if(agent.status === 3 || agent.status === 4) {
            startTransition5(async () => {
                await wait(1000);
                await getNextSchedules();
                setLoaded5(true);
            });
        }

    }, []);


    async function load_agente() {
        
        if(agent.status > 0) {

            let uid = user.id;
            let ida = agent.id;
            let pla = agent.plano;

            const agentdb = collection(db, "agents");
            const agentquery = query(agentdb, where("id_client", "==", uid), orderBy("data_criacao", "desc"), limit(1));

            const agentdoc = await getDocs(agentquery);
            try {

                // busca informações do agente
                setDadosAgent({
                    id: agentdoc.docs[0].id, 
                    nome: agentdoc.docs[0].data().nome, 
                    dt_criacao: formatTimestamp(agentdoc.docs[0].data().data_criacao),
                    numero: agentdoc.docs[0].data().telefone, 
                    status: agentdoc.docs[0].data().status,
                    dt_configuracao: "",
                    dt_ativacao: formatTimestamp(agentdoc.docs[0].data().data_inicio_ativacao),
                    dt_desativacao: formatTimestamp(agentdoc.docs[0].data().data_termino_ativacao),
                });

                if(agent.status === 3 || agent.status === 4) {

                    let rmo = "";
                    switch(pla.substring(0, 3)) {
                        case "CMD": 
                            rmo = "medical";
                            break;
                        case "EST":
                            rmo = "aesthetic";
                            break;
                    }
                    
                    const agentcontentdb = collection(db, rmo);
                    const agentcontentquery = query(agentcontentdb, where("id_agent", "==", ida), orderBy("data_criacao", "desc"), limit(1));

                    // busca a data de configuração do agente
                    const medicaldoc = await getDocs(agentcontentquery);
                    try {
                        setDadosAgent(da => ({ ...da, dt_configuracao: formatTimestamp(medicaldoc.docs[0].data().data_criacao)}));
                    }
                    catch(erro) {
                        alert("busca content agents " + erro);
                    }

                    if(agent.status === 3) {
                        setDifhrs(dateDiffDias(new Date(medicaldoc.docs[0].data().data_criacao.toDate()), new Date()).horas);
                    }  
                }                    
                
            }
            catch(erro) {
                alert("busca agente " + erro);
            }

        }

    }
    
    
    async function load_client() {

        let uid = user.id;
        
        const dbclients = collection(db, "clients");
        const queryclients = query(dbclients, where("id", "==", uid), limit(1));

        const clientsdoc = await getDocs(queryclients);
        try {
            setClient({
                empresa: clientsdoc.docs[0].data().empresa, 
                responsavel: clientsdoc.docs[0].data().responsavel, 
                email: clientsdoc.docs[0].data().email, 
                data_cadastro: formatTimestamp(clientsdoc.docs[0].data().data_criacao)
            });
        }
        catch(erro) {
            alert("busca client " + erro);
        }
        
    }



    async function load_payments() {

        let aid = agent.id;
        let cod = agent.plano;

        try {

            const billingsdb = collection(db, "billings");
            const billingsquery = query(billingsdb, where("id_agent", "==", aid), orderBy("data_criacao", "desc"), limit(1));

            const billingsdoc = await getDocs(billingsquery);

            //verifica a regularidade de pagamento
            const hoje = new Date();
            let atrasado = false;

            billingsdoc.forEach(docSnap => {const billing = docSnap.data();
                if (!Array.isArray(billing.parcelas)) return;

                const temAtraso = billing.parcelas.some(parcela => {const vencimento = parcela.vencimento?.toDate ? parcela.vencimento.toDate() : new Date(parcela.vencimento);
                    return parcela.status === "PENDING" && vencimento < hoje;
                });

                if(temAtraso) atrasado = true;
            });

            //verifica o plano
            const plansdb = collection(db, "plans");
            const plansquery = query(plansdb, where("codigo", "==", cod), limit(1));

            const plansdoc = await getDocs(plansquery);

            const dad = {assinatura: formatTimestamp(billingsdoc.docs[0].data().data_criacao), pagamento: billingsdoc.docs[0].data().tipo, vencimento: billingsdoc.docs[0].data().dia_vencimento, plano: plansdoc.docs[0].data().ramo, valor: plansdoc.docs[0].data().valor.toFixed(2), situacao: atrasado};
            
            setDadosBilling(dad);

        }
        catch(erro) {
            alert("busca billings " + erro);
        }

    }



    function execute_agent() {
        
        if(agent.status === 1) {
            switch(agent.plano.substring(0, 3)) {

                case "CMD":
                    navigate("/medical");
                    break;
                case "EST":
                    navigate("/aesthetic");
                    break;
            }

        } else if(agent.status === 3) {
            navigate("/billing");
        } else {
            navigate("/agent");
        }

    }


    async function create_chart() {
     
        try {
            
            let aid = agent.id;

            const agentref = doc(db, "agents", aid);
            const agentdoc = await getDoc(agentref);

            const tel = agentdoc.data().telefone;
            const dta = agentdoc.data().data_inicio_ativacao.toDate();

            //busca o id do agente do gptmaker
            const telephonesdb = collection(db, "telephones");
            const telephonequery = query(telephonesdb, where("telefone", "==", tel), limit(1));
            const telephonedoc = await getDocs(telephonequery);
            
            if (telephonedoc.empty) {
                throw new Error("Telefone não encontrado");
            }
        
            const idg = telephonedoc.docs[0].data().id_gptmaker;

            wait(500);

            const resGptMaker = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/dashs1",
                { method: "POST", headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    agent_id: idg,
                    start_date: "2025-07-01",
                    })
                });
           
            const resultGptMaker = await resGptMaker.json();
            if(resultGptMaker.error) {
                return;
            }

            const resumo = resultGptMaker.resumo;

            const diasResumo = resumo.por_dia || {};

            //garante chave string → objeto
            const dias_map = Object.keys(diasResumo).reduce((acc, key) => {acc[key] = diasResumo[key]; return acc;}, {});

            let chart = [];

            for (let i = 0; i < 7; i++) {
                const dia = new Date(dta);
                dia.setDate(dia.getDate() + i);

                const yyyy = dia.getFullYear();
                const mm = String(dia.getMonth() + 1).padStart(2, '0');
                const dd = String(dia.getDate()).padStart(2, '0');

                const key = `${yyyy}-${mm}-${dd}`;

                const dados = dias_map[key] || { resolvidos: 0, nao_resolvidos: 0 };

                chart.push({

                    dia: key,
                    resolvidos: dados.resolvidos,
                    nconcluido: dados.nao_resolvidos,
                    concluido: dados.resolvidos,
                    total: dados.resolvidos + dados.nao_resolvidos,
                    rotulo: `dia ${i + 1}`

                });
            }

            setChart(chart);
            
        } catch (erro) {
            alert("Erro ao montar gráfico: " + erro.message);
        }
        
    }


    async function getNextSchedules() {

        try {
    
            const diasRef = collection(db, "calendar", "3E364B1A0A99507FF12A023103FD214D", "dias");
            const snapshot = await getDocs(diasRef);

            const agora = new Date();
            const lista = [];

            snapshot.forEach((doc) => {

                const dia = doc.id; // YYYYMMDD
                const data = doc.data();

                const horarios = data.horarios;

                Object.keys(horarios).forEach((hora) => {const item = horarios[hora];
                
                if (item.livre === false && item.paciente) {

                    //construir Date completa com dia e hora
                    const ano = Number(dia.substring(0, 4));
                    const mes = Number(dia.substring(4, 6)) - 1;
                    const diaNum = Number(dia.substring(6, 8));

                    const [h, m] = hora.split(":").map(Number);
                    const dataCompleta = new Date(ano, mes, diaNum, h, m);

                    //apenas futuro
                    if (dataCompleta >= agora) {
                        lista.push({nome: item.paciente.nome, telefone: item.paciente.telefone || "", dia, hora, dataCompleta});
                    }

                }
                });
            });

            //ordenar por data/hora
            lista.sort((a, b) => a.dataCompleta - b.dataCompleta);

            //retornar somente os três primeiros
            const resultado = lista.slice(0, 3).map(item => ({nome: item.nome, dia: item.dia, hora: item.hora, telefone: item.telefone}));
            setAgenda(resultado);

        }
        catch(erro) {
            console.log(erro);
        }

    }



    return(

        <div className="context">

            <Header access={1}></Header>

            <div className="content">
                <div className="ft_topico">Painel do Cliente</div>
                <div className="ft_descricao">Esse é o Painel do Cliente, aqui você pode configurar seu agente, ver a peformance de atendimento dele, acompanhar seus pagamentos de mensalidade e alterar seus dados pessoais quando precisar.</div>
                <div className="space"></div>

                <div className="panel_box">
                    <div className="panel_box_space-mobile"></div>

                    <div className="panel_box_context">
                        <div className="panel_image_item"><img className="panel_image_item_content" src={panel_agent}></img></div>
                        <div className="panel_box_content">
                            <div className="panel_box_contentborder">
                                <div className="panel_box_contenttitle">Configure seu agente</div>
                                <span className="panel_box_contentaviso">Aqui é onde você cria, modifica e confere o status do seu agente.</span>
                                
                                <div className="panel_box_infos">
                                { !loaded1 ? (<><span className="panel_box_contentinfo_load">carregando ...</span></>) : (
                                    <>                           
                                    <span className="panel_box_contentitem">Nome do Agente:<span className="panel_box_contentresult">&nbsp;{ dadosAgent.nome }</span></span>
                                    <span className="panel_box_contentitem">Data de Criação:<span className="panel_box_contentresult">&nbsp;{ dadosAgent.dt_criacao }</span></span>
                                    <span className="panel_box_contentitem">Número do Agente:<span className="panel_box_contentresult">&nbsp;{ dadosAgent.numero }</span></span>
                                    <span className="panel_box_contentspace">
                                        <span className="panel_box_contentline"></span>
                                    </span>
                                    <span className="panel_box_contentitem">Status:<span className="panel_box_contentresult">&nbsp;{panel[0].textStatus}</span></span>
                                    <span className="panel_box_contentitem">{ agent.status > 4 ? "Data da Desativação:" : "Data da Configuração" }<span className="panel_box_contentresult">&nbsp;{ agent.status > 4 ? dadosAgent.dt_desativacao : dadosAgent.dt_configuracao }</span></span>
                                    <span className="panel_box_contentspace">
                                        <span className="panel_box_contentline"></span>
                                    </span>
                                    <span className="panel_box_contentitem">Data de Ativação:<span className="panel_box_contentresult">&nbsp;{ dadosAgent.dt_ativacao }</span></span>
                                    </>)}
                                </div>

                                <span className="panel_box_contentspace"></span>
                                <button type="button" name="bt1" className={!loaded1 ? "button_disabled_form" : panel[0].classButton} onClick={ execute_agent } disabled={!loaded1}>{panel[0].textButton}</button>
                            </div>
                        </div>
                    </div>

                    <div className="panel_box_space"></div>

                    <div className="panel_box_context">
                        <div className="panel_image_item"><img className="panel_image_item_content" src={panel_schedule}></img></div>
                        <div className="panel_box_content">
                            <div className="panel_box_contentborder">
                                <div className="panel_box_contenttitle">Agenda</div>
                                <span className="panel_box_contentaviso">Visualize todos os seus compromissos, tudo o que seus clientes agenadaram com você.</span>
                                
                                { panel[1].viewPanel ? (
                                <>
                                <div className="panel_box_contentchart">
                                    { !loaded2 ? (<><span className="panel_box_contentchart_load">carregando ...</span></>) : (
                                    <>
                                    <span>{agenda[0].nome}</span>
                                    </>)}
                                </div>
                                <span className="panel_box_contentspace"></span>
                                <button type="button" name="bt2" className={!loaded2 ? "button_disabled_form" : panel[1].classButton} onClick={ (e)=> navigate(agent.status === 3 ? "/billing" : "/performance") } disabled={!loaded2}>VER AGENDA</button>
                                </>
                                ) : (<><span className="panel_box_content_status">{panel[1].textPanel}</span><span className="panel_box_contentconfigure_space"></span></>)}

                            </div>
                        </div>
                    </div>

                    <div className="panel_box_space"></div>
                </div>

                <div className="space-mobile"></div>

                <div className="panel_box">
                    <div className="panel_box_space-mobile2"></div>
                    <div className="panel_box_context">
                        <div className="panel_image_item"><img className="panel_image_item_content" src={panel_graphics}></img></div>
                        <div className="panel_box_content">
                            <div className="panel_box_contentborder">
                                <div className="panel_box_contenttitle">Performance do agente</div>
                                <span className="panel_box_contentaviso">Verifique o desempenho do seu agente com base na produtividade de atendimentos.</span>
                                
                                { panel[2].viewPanel ? (
                                <>
                                <div className="panel_box_contentchart">
                                    { !loaded2 ? (<><span className="panel_box_contentchart_load">carregando ...</span></>) : (
                                    <>
                                    <ResponsiveContainer>
                                        <BarChart margin={{top: 20}} data={chart}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="rotulo" tick={{fontSize: 10}} />
                                        <YAxis hide={true} />
                                        <Tooltip />
                                        <Legend wrapperStyle={{fontSize: 11}} formatter={(value, entry) => {if (value === 'concluido') return 'Resolvido'; if (value === 'nconcluido') return 'Não Resolvido'; return value;}} />
                                        <Bar dataKey="concluido" stackId="a" fill="green" />
                                        <Bar dataKey="nconcluido" stackId="a" fill="red">
                                        <LabelList
                                            dataKey="nconcluido"
                                            position="top"
                                            content={(props) => {
                                            const { x, y, width, value, index } = props;
                                            const total = chart[index].concluido + chart[index].nconcluido;
                                            return (<text x={x + width / 2} y={y - 5} textAnchor="middle" fill="black" fontSize={12}>{total}</text>);
                                            }}
                                        />
                                        </Bar>
                                        </BarChart>
                                    </ResponsiveContainer>
                                    </>)}
                                </div>
                                <span className="panel_box_contentspace"></span>
                                <button type="button" name="bt2" className={!loaded2 ? "button_disabled_form" : panel[2].classButton} onClick={ (e)=> navigate(agent.status === 3 ? "/billing" : "/performance") } disabled={!loaded2}>VER MAIS</button>
                                </>
                                ) : (<><span className="panel_box_content_status">{panel[2].textPanel}</span><span className="panel_box_contentconfigure_space"></span></>)}

                            </div>
                        </div>
                    </div>

                    <div className="panel_box_space"></div>

                    <div className="panel_box_context">
                        <div className="panel_image_item"><img className="panel_image_item_content" src={panel_payment}></img></div>
                        <div className="panel_box_content">
                            <div className="panel_box_contentborder">
                                <div className="panel_box_contenttitle">Planos e pagamentos</div>
                                <span className="panel_box_contentaviso">Acompanhe o período de testes do seu agente, bem como o pagamento das mensalidades.</span>
                                { panel[3].viewPanel ? (
                                <>
                                <div className="panel_box_contentpayment">

                                { agent.status === 3 && (
                                <>
                                    { !loaded1 ? (<><span className="panel_box_contentchart_load">carregando ...</span></>) : 
                                    <>    
                                    <span className="panel_box_contentpayment_title">Período de testes gratuíto</span>
                                    <div className="panel_box_contentpayment_frame">
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#00B050", height: difhrs >= 24 ? "100%" : (difhrs * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 24 ? "4px" : "0px", borderTopRightRadius: difhrs >= 24 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 1</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#66C266", height: difhrs >= 48 ? "100%" : ((difhrs - 24) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 48 ? "4px" : "0px", borderTopRightRadius: difhrs >= 48 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 2</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#B7D77A", height: difhrs >= 72 ? "100%" : ((difhrs - 48) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 72 ? "4px" : "0px", borderTopRightRadius: difhrs >= 72 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 3</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#FFD966", height: difhrs >= 96 ? "100%" : ((difhrs - 72) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 96 ? "4px" : "0px", borderTopRightRadius: difhrs >= 96 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 4</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#F4B183", height: difhrs >= 120 ? "100%" : ((difhrs - 96) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 120 ? "4px" : "0px", borderTopRightRadius: difhrs >= 120 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 5</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#E06666", height: difhrs >= 144 ? "100%" : ((difhrs - 120) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 144 ? "4px" : "0px", borderTopRightRadius: difhrs >= 144 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 6</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#C00000", height: difhrs >= 168 ? "100%" : ((difhrs - 144) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 168 ? "4px" : "0px", borderTopRightRadius: difhrs >= 168 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 7</div>
                                        </div>
                                    </div>
                                    </>
                                    }
                                <span className="panel_box_contentspace"></span>
                                <button type="button" name="bt3a" className={!loaded1 ? "button_disabled_form" : panel[3].classButton} disabled={!loaded1} onClick={ (e)=> navigate("/billing") }>{panel[3].textButton}</button>
                                </>
                                )}

                                { agent.status === 4 && (
                                <>
                                    { !loaded4 ? (<><span className="panel_box_contentchart_load">carregando ...</span></>) : 
                                    <>
                                    <span className="panel_box_contentitem">Assinante desde:<span className="panel_box_contentresult">&nbsp;{ dadosBilling.assinatura }</span></span>
                                    <span className="panel_box_contentitem">Forma de Pagamento:<span className="panel_box_contentresult">&nbsp;{ dadosBilling.pagamento }</span></span>
                                    <span className="panel_box_contentitem">Vencimento (dia) :<span className="panel_box_contentresult">&nbsp;{ dadosBilling.vencimento }</span></span>
                                    <span className="panel_box_contentspace">
                                        <span className="panel_box_contentline"></span>
                                    </span>
                                    <span className="panel_box_contentitem">Plano:<span className="panel_box_contentresult">&nbsp;{ dadosBilling.plano }</span></span>
                                    <span className="panel_box_contentitem">Valor do Plano:<span className="panel_box_contentresult">&nbsp;{ "R$ " + dadosBilling.valor }</span></span>
                                    <span className="panel_box_contentspace">
                                        <span className="panel_box_contentline"></span>
                                    </span>
                                    <span className="panel_box_contentitem">Status Assinatura:<span className="panel_box_contentresult" style={{color: dadosBilling.situacao ? "red" : "green"}}>&nbsp;{ dadosBilling.situacao ? "Pagamento em atraso" : "Pagamentos em dia" }</span></span>
                                    <span className="panel_box_contentspace"></span>
                                    
                                    </>
                                    }
                                <button type="button" name="bt3a" className={!loaded4 ? "button_disabled_form" : panel[3].classButton} disabled={!loaded4} onClick={ (e)=> navigate("/billing") }>{panel[3].textButton}</button>
                                </>
                                )}

                                </div>
                                </>
                                ) : (<><span className="panel_box_content_status">{panel[3].textPanel}</span><span className="panel_box_contentconfigure_space"></span></>)}

                            </div>
                        </div>
                    </div>


                    <div className="panel_box_space-mobile2"></div>
                </div>

                <div className="space-mobile"></div>

                <div className="panel_box">
                    <div className="panel_box_space-mobile2"></div>
                    <div className="panel_box_context">
                        <div className="panel_image_item"><img className="panel_image_item_content" src={panel_config}></img></div>
                        <div className="panel_box_content">
                            <div className="panel_box_contentborder">
                                <div className="panel_box_contenttitle">Configurações</div>
                                <span className="panel_box_contentaviso">Altere seus dados cadastrais, sua senha e demais configurações.</span>
                                { panel[3].viewPanel ? (
                                <>
                                    { !loaded3 ? (<><span className="panel_box_contentchart_load">carregando ...</span></>) : (
                                    <>
                                    <div className="panel_box_contentconfigure">
                                        <span className="panel_box_contentitem">Empresa:</span>
                                        <span className="panel_box_contentresult">{ client.empresa }</span>
                                        <span className="panel_box_contentitem">Responsável:</span>
                                        <span className="panel_box_contentresult">{ client.responsavel }</span>
                                        <span className="panel_box_contentspace">
                                            <span className="panel_box_contentline"></span>
                                        </span>
                                        <span className="panel_box_contentitem">Email:<span className="panel_box_contentresult">&nbsp;{ client.email }</span></span>
                                        <span className="panel_box_contentitem">Data de Cadastro:<span className="panel_box_contentresult">&nbsp;{ client.data_cadastro }</span></span>
                                    </div>                            
                                    </>
                                    )}
                                <span className="panel_box_contentspace"></span>
                                <button type="button" name="bt4" className={!loaded3 ? "button_disabled_form" : panel[4].classButton} onClick={ (e)=> navigate(agent.status < 4 ? "/billing" : "/account") } disabled={!loaded3}>{panel[4].textButton}</button>
                                </>
                                ) : (<><span className="panel_box_content_status">{panel[4].textPanel}</span><span className="panel_box_contentconfigure_space"></span></>)}
                            </div>
                        </div>
                    </div>

                    <div className="panel_box_space"></div>

                    <div className="panel_box_context">
                        <div className="panel_image_item"></div>
                        <div className="panel_box_content"></div>
                    </div>

                    <div className="panel_box_space-mobile2"></div>
                </div>

                <div className="space"></div>
                <div className="space"></div>
                <div className="space"></div>

            </div>

            <Footer access={1}></Footer>

        </div>

    )
}